import { render, staticRenderFns } from "./CoinNetworkConcept.vue?vue&type=template&id=7511a2aa&scoped=true&"
import script from "./CoinNetworkConcept.vue?vue&type=script&lang=ts&"
export * from "./CoinNetworkConcept.vue?vue&type=script&lang=ts&"
import style0 from "./CoinNetworkConcept.vue?vue&type=style&index=0&id=7511a2aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7511a2aa",
  null
  
)

export default component.exports